export default "__VITE_ASSET__ChzJq53I__"